import styled from 'styled-components'
import { DefaultBackground } from '../../styles/global-styles'

export const Background = styled.div`
  ${DefaultBackground};
`

export const ModalWrapper = styled.div`
  position: fixed;
  top: 50vh;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  max-height: 100vh;
  overflow: hidden;
`
